<template>
  <div class="padding">
    <el-row>
      <el-col :span="24">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="日期" prop="date">
            <el-date-picker
              v-model="searchForm.date"
              :editable="false"
              :clearable="false"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="应用" prop="appIndex">
            <el-select v-model="searchForm.appIndex" placeholder="请选择">
              <el-option
                v-for="item in apps"
                :key="item.appIndex"
                :label="item.appName"
                :value="item.appIndex">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" native-type="submit" @click.native.prevent="submitSearch">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="24">
        <el-table :data="tableDate.rows" :stripe="true" v-loading="loading" border>
          <el-table-column prop="currentDate" label="时间"></el-table-column>
          <el-table-column prop="totalUserNum" label="总人数"></el-table-column>
          <el-table-column prop="totalDiamondNum" label="总钻石数"></el-table-column>
          <el-table-column prop="appIndex" label="应用名称">
            <template slot-scope="scope">
              {{findAppName(scope.row.appIndex)}}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="padding-vertical-md"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="tableDate.currentPage"
          :page-sizes="pageSizes"
          :page-size="tableDate.pageSize"
          :page-count="tableDate.totalPages"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableDate.count">
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import {getApps} from '@/api/apps'
  import statistics from '@/api/statistics'
  import constant from '@/utils/constant'
  import _Find_ from 'lodash/find'
  import moment from 'moment'

  function formatDate(date) {
    if (date) {
      return moment(date).format('YYYY-MM-DD')
    } else {
      return moment().format('YYYY-MM-DD')
    }
  }

  export default {
    name: 'expenseUser',
    data() {
      return {
        searchForm: {
          appIndex: null,
          date: [formatDate(), formatDate()]
        },
        tableDate: [],
        apps: null,
        loading: false,
        pageSizes: constant.PAGINATION.pageSizes
      }
    },
    created() {
      // 加载APP
      getApps().then(apps => {
        if (apps) {
          this.apps = apps
          this.searchForm.appIndex = apps[0].appIndex
        }
      })
    },
    methods: {
      submitSearch() {
        this.loadData({
          appIndex: this.searchForm.appIndex,
          beginTime: formatDate(this.searchForm.date[0]),
          endTime: formatDate(this.searchForm.date[1])
        });
      },
      handleSizeChange(val) {
        this.tableDate.pageSize = val;
        this.loadData({
          appIndex: this.searchForm.appIndex,
          beginTime: formatDate(this.searchForm.date[0]),
          endTime: formatDate(this.searchForm.date[1]),
          pageSize: val
        });
      },
      handleCurrentChange(val) {
        this.loadData({
          appIndex: this.searchForm.appIndex,
          beginTime: formatDate(this.searchForm.date[0]),
          endTime: formatDate(this.searchForm.date[1]),
          page: val,
          pageSize: this.tableDate.pageSize
        });
      },
      _Find_,
      findAppName(index) {
        return this._Find_(this.apps, {appIndex: index}).appName
      },
      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]))
      },
      export2Excel() {
        require.ensure([], () => {
          const {export_json_to_excel} = require('../../../vendor/Export2Excel');
          const tHeader = ['日期', '总人数', '总钻石数', '应用索引'];
          const filterVal = ['currentDate', 'totalUserNum', 'totalDiamondNum', 'appIndex'];
          const data = this.formatJson(filterVal, this.tableDate.all);
          export_json_to_excel(tHeader, data, '消费钻石');
        })
      },
      /**
       * 调用api方法
       * @param data
       */
      loadData(data) {
        statistics.getExpenseUser(data).then(result => {
          this.tableDate = result
        })
      }
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// expenseUser.vue?7bfff692